const optimizelyReducer = (state = {}, data) => {
    switch (data.type) {
        case 'SET_OPTIMIZELY_FEATURES':
            return {
                ...state,
                features: data.features,
            };
        default:
            return state;
    }
};

export default optimizelyReducer;
